// extracted by mini-css-extract-plugin
module.exports = {"ementas_digitais":"Backdrop_ementas_digitais__1ZbIQ","Backdrop":"Backdrop_Backdrop__1CyHd","chef_house":"Backdrop_chef_house__nTE6-"};